import axiosClient from "../../http-common";

class TasksApiService {
  getTasksAsync = async (tenantId, containerId, signal) => {
    return await axiosClient.get(
      `api/v1/tenants/${tenantId}/containers/${containerId}/tasks`,
      { signal }
    );
  };

  prepareTaskAsync = async (tenantId, containerId, taskId) => {
    return await axiosClient.post(`api/v1/tenants/${tenantId}/containers/${containerId}/tasks/${taskId}/prepare`);
  };
  
  deleteTaskAsync = async (tenantId, containerId, taskId) => {
    return await axiosClient.delete(`api/v1/tenants/${tenantId}/containers/${containerId}/tasks/${taskId}`);
  };

  getTaskExecutionContextAsync = async (taskId) =>{
    return await axiosClient.get(`api/v1/tasks/${taskId}/executionContext`);
  }
}

export default new TasksApiService();